import { Student } from '../types';

export const mockStudents: Student[] = [
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    studentIdNumber: 'S2024001',
    firstName: 'Emma',
    lastName: 'Johnson',
    email: 'emma.johnson@school.edu',
    grade: 9,
    pricingTier: 'full',
    parentIds: ['650e8400-e29b-41d4-a716-446655440001', '650e8400-e29b-41d4-a716-446655440006'],
    schoolId: '750e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    studentIdNumber: 'S2024002',
    firstName: 'Liam',
    lastName: 'Smith',
    email: 'liam.smith@school.edu',
    grade: 10,
    pricingTier: 'reduced',
    parentIds: ['650e8400-e29b-41d4-a716-446655440002', '650e8400-e29b-41d4-a716-446655440006'],
    schoolId: '750e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    studentIdNumber: 'S2024003',
    firstName: 'Olivia',
    lastName: 'Williams',
    email: 'olivia.williams@school.edu',
    grade: 11,
    pricingTier: 'free',
    parentIds: ['650e8400-e29b-41d4-a716-446655440003'],
    schoolId: '750e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    studentIdNumber: 'S2024004',
    firstName: 'Noah',
    lastName: 'Brown',
    email: 'noah.brown@school.edu',
    grade: 9,
    pricingTier: 'full',
    parentIds: ['650e8400-e29b-41d4-a716-446655440004'],
    schoolId: '750e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440005',
    studentIdNumber: 'S2024005',
    firstName: 'Ava',
    lastName: 'Davis',
    email: 'ava.davis@school.edu',
    grade: 12,
    pricingTier: 'reduced',
    parentIds: ['650e8400-e29b-41d4-a716-446655440005'],
    schoolId: '750e8400-e29b-41d4-a716-446655440001',
  },
];
